import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import {
  Card,
  Stack,
  Button,
  Container,
  Typography,
  CircularProgress,
  Box,
  TextField,
  Checkbox,
  FormControlLabel,
  Grid,
} from "@mui/material";
import Iconify from "../components/iconify";
import { useNavigate, useSearchParams } from "react-router-dom";
import { get, put } from "src/utils/networkUtils";

export default function ProfileEditPage() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.has("user_id")) {
      let userId = searchParams.get("user_id");
      get(`/admin/users/${userId}`).then(function (response) {
        setUser(response.user);
      });
    } else {
      navigate("/404");
    }
  }, [navigate, searchParams]);

  const handleChange = (e) => {
    const { id, value } = e.target;

    setUser((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };
  const handleChangeMobileNumberVerified = (e) => {
    if (e.target.checked) {
      setUser((prevState) => ({
        ...prevState,
        mobileNumberVerifiedAt: new Date().toISOString(),
      }));
    } else {
      setUser((prevState) => ({
        ...prevState,
        mobileNumberVerifiedAt: null,
      }));
    }
  };
  const handleChangeEmailNumberVerified = (e) => {
    if (e.target.checked) {
      setUser((prevState) => ({
        ...prevState,
        emailVerifiedAt: new Date().toISOString(),
      }));
    } else {
      setUser((prevState) => ({
        ...prevState,
        emailVerifiedAt: null,
      }));
    }
  };
  const handleChangeInabledVerified = (e) => {
    setUser((prevState) => ({
      ...prevState,
      isEnabled: e.target.checked,
    }));
  };

  const handleSubmitClick = async (e) => {
    e.preventDefault();
    setLoading(true);
    put(`/admin/users/${user.id}`, user).then((response) => {
      navigate(`/dashboard/profile?user_id=${user.id}`);
    });
  };

  return (
    <>
      <Helmet>
        <title> Profile Edit </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Profile Edit
          </Typography>
        </Stack>

        <Card sx={{ padding: 4 }}>
          {user === null || loading ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Grid item xs={3}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={user.isEnabled}
                          onChange={handleChangeInabledVerified}
                          id="isEnabled"
                        />
                      }
                      label="Enabled"
                    />
                  </Grid>
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    id="firstName"
                    label="First Name"
                    fullWidth
                    value={user.firstName}
                    variant="standard"
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    id="lastName"
                    label="Last Name"
                    fullWidth
                    value={user.lastName}
                    variant="standard"
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    id="username"
                    label="Username"
                    fullWidth
                    value={user.username}
                    variant="standard"
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    id="email"
                    label="Email"
                    fullWidth
                    value={user.email}
                    variant="standard"
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="mobileNumber"
                    label="Mobile Number"
                    fullWidth
                    value={user.mobileNumber}
                    variant="standard"
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="deviceId"
                    label="Device ID"
                    fullWidth
                    value={user.deviceId}
                    variant="standard"
                    onChange={handleChange}
                  />
                </Grid>
                {!user.mobileNumberVerified && (
                  <Grid item xs={12}>
                    <Grid item xs={3}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={user.mobileNumberVerifiedAt}
                            onChange={handleChangeMobileNumberVerified}
                            id="mobileNumberVerified"
                          />
                        }
                        label="Mobile Verified"
                      />
                    </Grid>
                  </Grid>
                )}
                {!user.emailVerified && (
                  <Grid item xs={12}>
                    <Grid item xs={3}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={user.emailVerifiedAt}
                            onChange={handleChangeEmailNumberVerified}
                            id="emailVerifiedAt"
                          />
                        }
                        label="Email Verified"
                      />
                    </Grid>
                  </Grid>
                )}
              </Grid>

              <Button
                variant="contained"
                startIcon={<Iconify icon="eva:save-outline" />}
                onClick={handleSubmitClick}
                sx={{ mt: 3 }}
                disabled={
                  user.firstName.length === 0 ||
                  user.lastName.length === 0 ||
                  user.email.length === 0 ||
                  user.username.length === 0 ||
                  user.mobileNumber.length === 0
                }
              >
                Save
              </Button>
            </>
          )}
        </Card>
      </Container>
    </>
  );
}
